// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assessment-details-chart {
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.assessment-details-empty {
  padding: 40px;
  text-align: center;
  color: #64748b;
  font-size: 16px;
}

.category-section {
  margin-bottom: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: box-shadow 0.2s;
}

.category-section:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.2s;
}

.category-header:hover {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
}

.category-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
}

.expand-icon {
  color: #64748b;
  transition: transform 0.2s;
}

.category-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
}

.category-stats {
  display: flex;
  gap: 12px;
  align-items: center;
}

.stat-badge {
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #475569;
}

.score-badge {
  background: linear-gradient(135deg, hsl(159, 100%, 51%) 0%, hsl(152, 60%, 30%) 100%);
  color: #ffffff;
  border: none;
  font-weight: 600;
}

.questions-container {
  padding: 12px;
  background: #ffffff;
}

.question-item {
  margin-bottom: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f8fafc;
  overflow: hidden;
  transition: all 0.2s;
}

.question-item:hover {
  border-color: hsl(159, 100%, 51%);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.question-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.question-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
}

.expand-icon-small {
  color: #94a3b8;
  flex-shrink: 0;
}

.answer-icon {
  flex-shrink: 0;
}

.answer-icon.not-answered {
  color: #cbd5e1;
}

.answer-icon.answered-good {
  color: #10b981;
}

.answer-icon.answered-medium {
  color: #f59e0b;
}

.answer-icon.answered-poor {
  color: #ef4444;
}

.question-text {
  flex: 1 1;
  font-size: 14px;
  font-weight: 500;
  color: #334155;
  line-height: 1.5;
}

.question-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.question-score {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.question-type-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  background: #e2e8f0;
  color: #475569;
  letter-spacing: 0.5px;
}

.answer-details {
  padding: 16px;
  background: #ffffff;
  border-top: 1px solid #e2e8f0;
  margin-top: 8px;
}

.answer-section {
  margin-bottom: 12px;
}

.answer-section strong {
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.answer-value {
  padding: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  color: #1e293b;
  line-height: 1.6;
  word-break: break-word;
}

.answer-meta {
  margin-top: 8px;
  font-size: 12px;
  color: #64748b;
}

.answer-meta strong {
  color: #475569;
  margin-right: 4px;
}

@media (max-width: 768px) {
  .category-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .category-stats {
    width: 100%;
    justify-content: flex-start;
  }

  .question-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .question-meta {
    width: 100%;
    flex-wrap: wrap;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/charts/AssessmentDetailsChart.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,8JAA8J;AAChK;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oFAAoF;EACpF,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":[".assessment-details-chart {\r\n  width: 100%;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\r\n}\r\n\r\n.assessment-details-empty {\r\n  padding: 40px;\r\n  text-align: center;\r\n  color: #64748b;\r\n  font-size: 16px;\r\n}\r\n\r\n.category-section {\r\n  margin-bottom: 16px;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  background: #ffffff;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\r\n  overflow: hidden;\r\n  transition: box-shadow 0.2s;\r\n}\r\n\r\n.category-section:hover {\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.category-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 16px 20px;\r\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\r\n  cursor: pointer;\r\n  user-select: none;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.category-header:hover {\r\n  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);\r\n}\r\n\r\n.category-header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  flex: 1;\r\n}\r\n\r\n.expand-icon {\r\n  color: #64748b;\r\n  transition: transform 0.2s;\r\n}\r\n\r\n.category-title {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #1e293b;\r\n}\r\n\r\n.category-stats {\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: center;\r\n}\r\n\r\n.stat-badge {\r\n  padding: 6px 12px;\r\n  border-radius: 6px;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  background: #ffffff;\r\n  border: 1px solid #e2e8f0;\r\n  color: #475569;\r\n}\r\n\r\n.score-badge {\r\n  background: linear-gradient(135deg, hsl(159, 100%, 51%) 0%, hsl(152, 60%, 30%) 100%);\r\n  color: #ffffff;\r\n  border: none;\r\n  font-weight: 600;\r\n}\r\n\r\n.questions-container {\r\n  padding: 12px;\r\n  background: #ffffff;\r\n}\r\n\r\n.question-item {\r\n  margin-bottom: 8px;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 6px;\r\n  background: #f8fafc;\r\n  overflow: hidden;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.question-item:hover {\r\n  border-color: hsl(159, 100%, 51%);\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.question-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 12px 16px;\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.question-header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.expand-icon-small {\r\n  color: #94a3b8;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.answer-icon {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.answer-icon.not-answered {\r\n  color: #cbd5e1;\r\n}\r\n\r\n.answer-icon.answered-good {\r\n  color: #10b981;\r\n}\r\n\r\n.answer-icon.answered-medium {\r\n  color: #f59e0b;\r\n}\r\n\r\n.answer-icon.answered-poor {\r\n  color: #ef4444;\r\n}\r\n\r\n.question-text {\r\n  flex: 1;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #334155;\r\n  line-height: 1.5;\r\n}\r\n\r\n.question-meta {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.question-score {\r\n  font-size: 12px;\r\n  color: #64748b;\r\n  font-weight: 500;\r\n}\r\n\r\n.question-type-badge {\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  background: #e2e8f0;\r\n  color: #475569;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.answer-details {\r\n  padding: 16px;\r\n  background: #ffffff;\r\n  border-top: 1px solid #e2e8f0;\r\n  margin-top: 8px;\r\n}\r\n\r\n.answer-section {\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.answer-section strong {\r\n  display: block;\r\n  margin-bottom: 8px;\r\n  font-size: 13px;\r\n  color: #64748b;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.answer-value {\r\n  padding: 12px;\r\n  background: #f8fafc;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  color: #1e293b;\r\n  line-height: 1.6;\r\n  word-break: break-word;\r\n}\r\n\r\n.answer-meta {\r\n  margin-top: 8px;\r\n  font-size: 12px;\r\n  color: #64748b;\r\n}\r\n\r\n.answer-meta strong {\r\n  color: #475569;\r\n  margin-right: 4px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .category-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 12px;\r\n  }\r\n\r\n  .category-stats {\r\n    width: 100%;\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .question-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 8px;\r\n  }\r\n\r\n  .question-meta {\r\n    width: 100%;\r\n    flex-wrap: wrap;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
